<template>
    <quick-tips :tips="tips"/>
  </template>
  
  <script>
  import QuickTips from '@/components/QuickTips.vue';
  
  export default {
    components: {
      QuickTips,
    },
    data() {
      return {
        tips: [],
      };
    },
    created() {
      this.tips = [
        {
          body: [
            `The Review Retire/Merge ID Confirmation panel will display the "ID to Retire" and the "ID to Merge To".`,
          ],
        },
        {
          body: [
            `The end user should be certain the data for the ID to Retire has been verified before clicking the Retire ID and Merge Records action button on the Review Retire/Merge ID Confirmation panel.
            The actions cannot be reverted beyond this point.`,
          ],
        },
        {
          body: [
            `Type a Reason of Retirement in the text box. It is required.`,
          ],
        },
        {
          body: [
            `To Merge the History records of the "ID to Retire" to the "ID to Merge To" select "Yes" for the Merge History Records option.
            The Master Record is always merged to the “ID to Merge To”.`
          ],
        },
        {
          header: 'Important: ',
          body: [
            `RETIREMENTS CANNOT BE REVERTED.`,
          ],
        },
      ];
    },
  };
  </script>
  
  <style lang="sass" scoped>
  </style>
  